import { ReactComponent as DefaultCampaignsIcon } from './svg/defaultCampaigns.svg'

export default DefaultCampaignsIcon
